import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import DialogModal from 'components/modal/DialogModal/DialogModal'
import Link from 'components/ui/Link/Link'
import Message from 'components/text/Message/Message'

import messages from './messages'
import s from './LoginRequiredModal.scss'


class LoginRequiredModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.review.LoginRequired,
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name, data: { toWhatText, urlToProduct }, data } = this.props

    const loginUrl    = urlToProduct ? `${links.login}?goto=${urlToProduct}` : links.login
    const registerUrl = urlToProduct ? `${links.register}?redirect=${urlToProduct}` : links.register

    return (
      <DialogModal
        name={name}
        buttonTitle={messages.button}
        data={data}
      >
        <FormattedMessage {...messages.please} />&nbsp;
        <Link className={s.link} customColor title={messages.login} to={loginUrl} onClick={this.close} />&nbsp;
        <FormattedMessage {...messages.or} />&nbsp;
        <Link className={s.link} customColor title={messages.register} to={registerUrl} onClick={this.close} />&nbsp;
        <Message text={toWhatText} />
      </DialogModal>
    )
  }
}


export default LoginRequiredModal
